export const guides = (state) => state.guides;
export const guidesLoading = (state) => state.getGuides.loading;
export const guidesError = (state) => state.getGuides.error;

export const basicsGuides = (state) =>
  state.guides.filter((g) => g.category.toLowerCase() === 'basics');

export const nonBasicsGuides = (state) =>
  state.guides.filter((g) => g.category.toLowerCase() !== 'basics');

export const guideByGroup = (state) => state.guideByGroup.data;
export const guideByGroupLoading = (state) => state.guideByGroup.loading;
export const guideByGroupError = (state) => state.guideByGroup.error;
